<template>
  <div class="page-footer">
    <!-- Sponsors Section (optional) -->
    <section v-if="showSponsors" class="sponsors-section">
      <div class="section-container">
        <div class="section-header-center">
          <h2 class="section-title-white">{{ sponsorTitle }}</h2>
        </div>
        
        <sponsor-carousel 
          :autoplayTimeout="3000"
          :sponsors="sponsorBanners"
        />
      </div>
    </section>

    <!-- Copyright Footer -->
    <footer class="auth-footer">
      <div class="footer-content">
        <p>{{ copyrightText }}</p>
      </div>
    </footer>
  </div>
</template>

<script>
import SponsorCarousel from './SponsorCarousel.vue'

export default {
  name: "AppPageFooter",
  components: {
    SponsorCarousel
  },
  data() {
    return {
      sponsorBanners: [],
    }
  },
  methods: {
    loadSponsorBanners() {
      if (!this.$http || !this.$settings) {
        console.warn('HTTP client or settings not available, using static sponsors');
        this.sponsorBanners = this.getStaticSponsors();
        return Promise.resolve();
      }
      
      const baseURI = this.$settings.endPoint + "get-banner";
      return this.$http
        .get(
          baseURI +
          `?limit=10&page=1&sort_field=&sort_type=&title=&link=&priority=&location=sponsor`,
          {
            timeout: 10000,
            'headers': {
              'AppToken': this.$settings.jwtSecret,
            }
          }
        )
        .then((response) => {
          this.sponsorBanners = response.data.datas || [];
          
          if (this.sponsorBanners.length === 0) {
            this.sponsorBanners = this.getStaticSponsors();
          }
        }).catch(error => {
          console.log('Error loading sponsor banners:', error);
          this.sponsorBanners = this.getStaticSponsors();
        });
    },
    getStaticSponsors() {
      return [
        { 
          id: 1, 
          title: 'Isntree', 
          image: require('@/assets/isntree.svg'),
          link: '#'
        },
        { 
          id: 2, 
          title: 'Laneige', 
          image: require('@/assets/laneige.svg'),
          link: '#'
        },
        { 
          id: 3, 
          title: 'Aestura', 
          image: require('@/assets/aestura.svg'),
          link: '#'
        },
        { 
          id: 4, 
          title: 'Isntree', 
          image: require('@/assets/isntree.svg'),
          link: '#'
        },
        { 
          id: 5, 
          title: 'Laneige', 
          image: require('@/assets/laneige.svg'),
          link: '#'
        },
        { 
          id: 6, 
          title: 'Aestura', 
          image: require('@/assets/aestura.svg'),
          link: '#'
        }
      ];
    },
  },
  mounted() {
    this.loadSponsorBanners()
  },
  props: {
    showSponsors: {
      type: Boolean,
      default: true
    },
    sponsorTitle: {
      type: String,
      default: "Sponsor Hadiah Bert Points"
    },
    sponsors: {
      type: Array,
      default: () => [
        {
          id: 1,
          name: "IsyTree",
          logo: "@/assets/isntree.svg"
        },
        {
          id: 2,
          name: "LANEIGE",
          logo: require("@/assets/laneige.svg")
        },
        {
          id: 3,
          name: "AESTURA",
          logo: require("@/assets/aestura.svg")
        },
        {
          id: 4,
          name: "IsyTree",
          logo: require("@/assets/isntree.svg")
        },
        {
          id: 5,
          name: "LANEIGE",
          logo: require("@/assets/laneige.svg"),
        },
        {
          id: 6,
          name: "AESTURA",
          logo: require("@/assets/aestura.svg"),
        }
      ]
    },
    copyrightText: {
      type: String,
      default: "© Copyright 2025 Bert Solution All rights reserved."
    }
  }
};
</script>

<style scoped>
.page-footer {
  width: 100%;
}

/* ========================================= */
/* SPONSORS SECTION                           */
/* ========================================= */
.sponsors-section {
  background: #4A90E2;
  padding: 2.5rem 1rem; /* Reduced horizontal padding */
  color: white;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden; /* Prevent horizontal overflow */
}

.section-container {
  max-width: 1100px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden; /* Prevent horizontal overflow */
}

.section-header-center {
  margin-bottom: 2rem;
}

.section-title-white {
  color: white;
  font-weight: 700;
  margin: 0;
  font-size: 2rem;
}
/* ========================================= */
/* COPYRIGHT FOOTER                           */
/* ========================================= */

.auth-footer {
  background: #2c3e50;
  color: white;
  padding: 1rem 0;
  text-align: center;
}

.footer-content p {
  margin: 0;
  font-size: 0.9rem;
}
/* ========================================= */
/* MOBILE RESPONSIVE STYLES                  */
/* ========================================= */
@media (max-width: 768px) {
  .section-container {
    max-width: 350px;
    padding: 0 5px; /* Minimal padding */
  }
  
  .sponsors-section {
    padding: 2rem 0.5rem; /* Reduced padding */
  }

  .section-title-white {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .footer-content p {
    font-size: 0.8rem;
    padding: 0 1rem;
  }
}

@media (max-width: 480px) {
  .section-container {
    max-width: 350px;
    padding: 0 2px; /* Minimal padding */
  }
  
  .sponsors-section {
    padding: 1.5rem 0.25rem; /* Very minimal padding */
  }
  
  .section-title-white {
    font-size: 1.3rem;
  }
}
</style>